import { IPricingRepository } from '../../application/ports/repositories/IPricingRepository';
import { PricingDataSource } from './PricingAPIDataSource';
import { PricingData } from '../../entities/model/PricingData';
import { PricingRequestDTO } from '../../frameworks_drivers/dtos/PricingRequestDTO';

export class PricingRepositoryImpl implements IPricingRepository {
  dataSource: PricingDataSource;

  constructor(dataSource: PricingDataSource) {
    this.dataSource = dataSource;
  }

  async getPricingData(pricingRequestDTO: PricingRequestDTO): Promise<PricingData> {
    return await this.dataSource.getPricingData(pricingRequestDTO);
  }

  async getFullPricingData(pricingRequestDTO: PricingRequestDTO): Promise<PricingData> {
    return await this.dataSource.getFullPricingData(pricingRequestDTO);
  }
}
